// PublicPageTheme.js
// Fixed light theme for public-facing pages (application form, learn more, etc.).
// Visitors on these pages are not portal users, so the pages must never inherit
// a logged-in user's dark mode or custom theme colors from ThemeContext. They do
// take the company's brand colors (a partner's primary/secondary), so a partner's
// application form and sign pages look like that partner, not White Knight.
//
// The nested ThemeProvider alone is not enough: the global <CssBaseline /> in App.js
// writes the logged-in user's text color and background onto <body>, and any text
// without an explicit color inherits it. ScopedCssBaseline re-applies baseline
// text/background colors to this subtree from the fixed light theme, which blocks
// that inheritance.
import React, { useMemo } from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import ScopedCssBaseline from '@mui/material/ScopedCssBaseline';
import { getThemeConfig } from '../theme';
import { useOrg } from '../context/OrgContext';

const PublicPageTheme = ({ children }) => {
  const { isPlatform, colors } = useOrg();
  const theme = useMemo(
    () => createTheme(getThemeConfig('light', isPlatform ? {} : { primary: colors.primary, secondary: colors.secondary })),
    [isPlatform, colors]
  );
  return (
    <ThemeProvider theme={theme}>
      <ScopedCssBaseline sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
        {children}
      </ScopedCssBaseline>
    </ThemeProvider>
  );
};

export default PublicPageTheme;
